import React from 'react';
import PropTypes from 'prop-types';

import AuthLayout from '@dashboard/layouts/AuthLayout';

import { FormElement, Label } from '@dashboard/components/Form';
import { Button } from '@dashboard/components/ui/button';
import { cn } from '@dashboard/lib/utils';
import { Input } from '@dashboard/components/ui/input';
import { FormErrorBase } from '@dashboard/components/Formik/components/FormError';
import Meta from '@dashboard/components/Meta';
import {
  AuthFooter,
  AuthHeader,
  AuthLink,
  authButtonClassName,
  authInputClassName,
  authLink,
} from '@dashboard/components/AuthForm';
import { appUrl } from '@/dashboard/services/env';

const propTypes = {
  form: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleStartOver: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

const AccountForgotPassword = props => {
  const { form, handleInputChange, handleSubmit, handleStartOver, submitting } = props;
  const isSent = form.saved && !form.message;

  return (
    <>
      <Meta
        meta={{
          title: 'Forgot password',
        }}
      >
        <link rel="canonical" href={`${appUrl}/forgot-password`} />
      </Meta>

      <AuthLayout>
        {isSent ? (
          <div role="status">
            <AuthHeader
              title="Check your email"
              description={`If an account uses ${form.state.email}, we have sent a password reset link to it. If it does not arrive in a few minutes, check your spam folder.`}
            />
            <p className="text-sm text-gray-600 dark:text-muted-foreground">
              Wrong email?{' '}
              <button type="button" onClick={handleStartOver} className={authLink}>
                Use a different email
              </button>
            </p>
          </div>
        ) : (
          <>
            <AuthHeader
              title="Reset your password"
              description="Enter the email you signed up with. We will send you a link to set a new password."
            />

            <form onSubmit={e => handleSubmit(e)}>
              <FormElement>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="name@example.com"
                  value={form.state.email}
                  onChange={e => handleInputChange(e)}
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  className={authInputClassName}
                  required
                />
              </FormElement>

              {form.message && <FormErrorBase className="mb-4">{form.message}</FormErrorBase>}

              <Button
                type="submit"
                size="xl"
                disabled={submitting}
                className={cn('w-full', authButtonClassName)}
              >
                Send reset email
              </Button>
            </form>
          </>
        )}

        <AuthFooter>
          Back to{' '}
          <AuthLink path="/login" email={form.state.email}>
            log in
          </AuthLink>
        </AuthFooter>
      </AuthLayout>
    </>
  );
};

AccountForgotPassword.propTypes = propTypes;

export default AccountForgotPassword;
